<template>
  <div>
    <BaseButton type="button" primary outline small class="flex items-center" @click="editAudience">
      <span>Edit</span>
    </BaseButton>
  </div>
</template>

<script>
import { audiencesClient } from '@/api/clients';

export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
    onUpdated: {
      type: Function,
      default: () => {
        //
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async updateAudience(data) {
      try {
        const response = await audiencesClient.update(this.audience.id, data);

        this.onUpdated(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    editAudience() {
      this.$modal.show({
        component: () => import('Components/Audience/AudienceModal.vue'),
        props: {
          action: this.updateAudience,
          defaultData: {
            id: this.audience.id,
            name: this.audience.name || '',
            description: this.audience.description || '',
            source: 'facebook',
            facebook_ad_account_id: this.audience.model.facebook_account_id,
            facebook_audience_type: this.audience.model_type,
            facebook_audience_id: this.audience.model_id,
            cover: this.audience?.cover || null,
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
